import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { AlertTriangle, RefreshCw } from 'lucide-react';
import { useToast } from '@/hooks/use-toast';

const Integration = () => {
  const { toast } = useToast();

  const handleRefreshData = () => {
    toast({
      title: "Data Refresh",
      description: "Registry data refresh initiated.",
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Integration Hub</h1>
          <p className="text-muted-foreground">
            Manage registry data and external integrations.
          </p>
        </div>
        
        <Card>
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <RefreshCw className="w-5 h-5" />
              Registry Data Management
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="space-y-4">
              <div className="flex items-center justify-between">
                <div>
                  <h4 className="font-medium">Data Synchronization</h4>
                  <p className="text-sm text-muted-foreground">Keep your registry data up to date</p>
                </div>
                <Button onClick={handleRefreshData}>
                  Refresh Data
                </Button>
              </div>
              
              <div className="p-4 bg-muted/50 rounded-lg">
                <div className="flex items-center gap-2 mb-2">
                  <Badge variant="secondary">Active</Badge>
                  <span className="text-sm font-medium">Registry Status</span>
                </div>
                <p className="text-sm text-muted-foreground">
                  Registry is operational and accepting new project registrations.
                </p>
              </div>
            </div>
          </CardContent>
        </Card>
      </main>
    </div>
  );
};

export default Integration;